<template>
  <div>
    <!--搜索-->
    <div>
      <van-search
          v-model="queryParams.goodsName"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          style="padding:12px 12px"
          :clearable="false"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <!-- 列表 -->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
          v-model="data.bottomLoading"
          :finished="!data.hasMore"
          finished-text="没有更多了"
          @load="bottomRefresh()"
      >
        <div class="list-box" v-for="(item, index) in data.records" :key="index"
             @click="$router.push(`/my/entrust/detail?id=${item.id}`)">
          <div class="box">
            <b>{{ item.bailmentNo }}</b>
            <b :style="`color: ${item.status === '1' ? '#1989fa' : '#ff0000'}`">{{ item.status === '1' ? '已完成' : '未完成' }}</b>
          </div>
          <div class="box">
            <span>{{ item.goodsName }}</span>
            <span>取件码：{{ item.code }}</span>
          </div>
          <div class="box-button">
            <van-button size="small" type="primary" @click.stop="handleExport(item.id)">下载寄托单</van-button>
            <van-button v-if="item.status === '0'" size="small" type="info" @click.stop="handleOk(item.id)">完成</van-button>
            <van-button size="small" type="danger" @click.stop="handleDel(item.id)">删除</van-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="vbut">
    <van-button @click="$router.push('/my/entrust/add')">新增</van-button>
    </div>
  </div>
</template>

<script>
import {queryList, del, complete, exportPdf} from '@/api/entrust/entrust'
import {handlePageData} from '@/utils/common'
import { Dialog } from 'vant';

export default {
  name: 'EntrustList',
  components: {},
  data() {
    return {
      queryParams: {},
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.reset()
      this.getList()
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },
    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size

      queryList(this.queryParams).then(res => {
        if (res.code === 10000) {
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    },
    onSearch() {
      this.refresh()
    },
    handleExport(id) {
      exportPdf(id).then(res => {
        if (res.code === 10000) {
          this.$toast("下载成功")
        }
      })
    },
    handleOk(id) {
      Dialog.confirm({
        title: '确认完成？',
        message: '',
      })
      .then(() => {
        complete({id}).then(res => {
          if (res.code === 10000) {
            this.$toast("更新成功！");
            this.refresh()
          }
        })
      })
      .catch(() => {
        // on cancel
      });
    },
    handleDel(id) {
      Dialog.confirm({
        title: '确认删除？',
        message: '',
      })
      .then(() => {
        del({id}).then(res => {
          if (res.code === 10000) {
            this.$toast("删除成功！");
            this.refresh()
          }
        })
      })
      .catch(() => {
        // on cancel
      });
    }
  }
}
</script>
<style scoped>
.vbut{
  position: fixed;
  bottom: 60px;
  width: 100%;
  padding: 0 2%;
}
.vbut .van-button
{
  height: 45px;
  background: #2C68E4;
  border-radius: 3px;
  width: 100%;
  color: #ffffff;
}
.list-box {
  height: auto;
}

.list-box .box {
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.list-box .box-button {
  padding: 10px 15px;
  display: flex;
}

.list-box .box-button button {
  margin-right: 10px;
}
</style>
